import $ from 'jquery';
import axios from 'axios';
import RuntimeUtils from 'src/common/js/runtimeUtils';

export const get = (url, params = {}) =>
    new Promise((resolve, reject) => {
        axios
            .get(url, { params })
            .then(
                (res) => {
                    resolve(res.data);
                },
                (err) => {
                    reject(err);
                },
            )
            .catch((err) => {
                reject(err);
            });
    });

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, data)
            .then(
                (res) => {
                    resolve(res.data);
                },
                (err) => {
                    reject(err);
                },
            )
            .catch((err) => {
                reject(err);
            });
    });
}

export function axios_post_formData(url, data = {}) {
    return new Promise((resolve, reject) => {
        // 设置axios为form-data
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        axios.defaults.transformRequest = [
            function(data) {
                let ret = '';
                for (const it in data) {
                    ret += `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
                }
                return ret;
            },
        ];
        axios
            .post(url, data)
            .then(
                (res) => {
                    resolve(res.data);
                },
                (err) => {
                    reject(err);
                },
            )
            .catch((err) => {
                reject(err);
            });
    });
}

// 统一控制jQuery请求方法
export const $get = (url, data = {},headers) => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    // path=/bimserver/console/v3/
    // document.cookie = 'SESSION=MGIzNWY2OGYtOGFiNS00NzNiLWJhY2UtZDhmODY5NzJiYmU2; path=/bimserver/console/v3/'
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url,
            crossDomain: true, // 设置跨域为true
            xhrFields: {
                withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
            },
            data,
            beforeSend(request) {
                if(headers)
                {
                    request.setRequestHeader('Authorization', `Bearer ${headers}`);
                }
            },
            success(res) {
                resolve(res);
            },
            error(err) {
                console.log(err.responseText);
                switch (err.status) {
                    case 401:
                    case 403:
                        window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
                        break;
                    case 500:
                        this.$message.error('服务器内部错误');
                }
                reject(err);
            },
        });
    });
};
export const $getWithOutRedirect = (url) => {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url,
            crossDomain: true, // 设置跨域为true
            xhrFields: {
                withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
            },
            success(res) {
                resolve(res);
            },
            error(err) {
                reject(err);
            },
        });
    });
};
// 统一控制jQuery请求方法
export const $delete = (url, data = {}) => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    // path=/bimserver/console/v3/
    // document.cookie = 'SESSION=MGIzNWY2OGYtOGFiNS00NzNiLWJhY2UtZDhmODY5NzJiYmU2; path=/bimserver/console/v3/'
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'DELETE',
            url,
            crossDomain: true, // 设置跨域为true
            xhrFields: {
                withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
            },
            data: JSON.stringify(data),
            success(res) {
                resolve(res);
            },
            beforeSend(request) {
                request.setRequestHeader('Content-Type', 'application/json');
            },
            error(err) {
                switch (err.status) {
                    case 200:
                        resolve({});
                        break;
                    case 401:
                    case 403:
                        window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
                        break;
                    case 500:
                        this.$message.error('服务器内部错误');
                }
                reject(err);
            },
        });
    });
};

// 统一控制jQuery请求方法
export const $post = (url, data = {},headers) => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST',
            url,
            crossDomain: true, // 设置跨域为true
            xhrFields: {
                withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
            },
            data: JSON.stringify(data),
            beforeSend(request) {
                if(headers)
                {
                    request.setRequestHeader('Authorization', `Bearer ${headers}`);
                }
                request.setRequestHeader('Content-Type', 'application/json');
            },
            success(res) {
                resolve(res);
            },
            error(err) {
                console.log(err.responseText);
                switch (err.status) {
                    case 200:
                        resolve({});
                        break;
                    case 401:
                    case 403:
                        window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
                        break;
                    case 500:
                        this.$message.error('服务器内部错误');
                    default:
                        console.warn(err.responseText);
                }
                reject(err);
            },
        });
    });
};

export const $put = (url, data = {}) => {
    const clientId = RuntimeUtils.instance.getClientId();
    const redirectUri = RuntimeUtils.instance.getPassportServiceHostname();
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'PUT',
            url,
            crossDomain: true, // 设置跨域为true
            xhrFields: {
                withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
            },
            data: JSON.stringify(data),
            beforeSend(request) {
                request.setRequestHeader('Content-Type', 'application/json');
            },
            success(res) {
                resolve(res);
            },
            error(err) {
                console.log(err.responseText);
                switch (err.status) {
                    case 200:
                        resolve({});
                        break;
                    case 401:
                    case 403:
                        window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`;
                        break;
                    case 500:
                        this.$message.error('服务器内部错误');
                    default:
                        console.error(err.responseText);
                }
                reject(err);
            },
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/httpUtil.js